/**
 * Temporary front-end-only login for demos / local UI work.
 * Does not call the backend — real credentials still go through authApi.
 */
export const TEMP_DEMO_EMAIL = 'admin@salzburgcab.com'
export const TEMP_DEMO_PASSWORD = 'demo123'
export const TEMP_DEMO_TOKEN = 'temp_demo_session'


export const isTempDemoLogin = (email: string, password: string) =>
  email.trim().toLowerCase() === TEMP_DEMO_EMAIL && password === TEMP_DEMO_PASSWORD

/** Writes the same session keys the real API login uses, so Header / Profile keep working. */
export const applyTempDemoSession = (email: string = TEMP_DEMO_EMAIL) => {
  localStorage.setItem('user_email', email)
  localStorage.setItem('auth_token', TEMP_DEMO_TOKEN)
  const existingProfile = localStorage.getItem('salzburg_profile_details')
  if (!existingProfile) {
    localStorage.setItem(
      'salzburg_profile_details',
      JSON.stringify({
        name: 'Alexander Wright',
        email: email,
        phone: '+43 664 1234567',
        avatar: '/assets/dashboard/profile/profile-avatar.png',
        has_password: true,
      }),
    )
  }
  localStorage.setItem(
    'user_data',
    JSON.stringify({
      name: 'Alexander Wright',
      email: email,
      phone: '+43 664 1234567',
    }),
  )
}
